/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {getUserData} from '@common'
import {UserRole} from '@enums'
import {getUserSelectionAtom} from '@state'

import {useQuery} from '@tanstack/react-query'
import {getDefaultStore} from 'jotai'

import {getContractType, getContractTypeNames, getContractTypesByCompany} from './api'
import {contractTypeKeys} from './keys'
import {ContractTypeResponse} from './types'

export const useContractTypes = () => {
  return useQuery<ContractTypeResponse[], unknown>({
    queryKey: contractTypeKeys.lists(),
    queryFn: async () => {
      const currentUser = getUserData()
      const userSelectionMap = getDefaultStore().get(getUserSelectionAtom)
      const userSelection = userSelectionMap[currentUser.id]

      if (!userSelection?.companyId) return []

      const contractTypes = await getContractTypesByCompany(userSelection.companyId)

      if (currentUser.role === UserRole.COMPANY_USER) {
        return contractTypes.filter(ct => ct.allowedDealers.map(d => d.id).includes(currentUser.dealerId || ''))
      }

      return contractTypes
    },
  })
}

export const useContractType = (id?: string) => {
  return useQuery<ContractTypeResponse, unknown>({
    queryKey: contractTypeKeys.detail(id || ''),
    queryFn: () => getContractType(id!),
    enabled: !!id,
  })
}

export const useContractTypesByCompany = (companyId?: string) => {
  return useQuery<ContractTypeResponse[], unknown>({
    queryKey: contractTypeKeys.byCompany(companyId || ''),
    queryFn: () => getContractTypesByCompany(companyId!),
    enabled: !!companyId,
  })
}

export const useContractTypeNames = () => {
  return useQuery<string[], unknown>({
    queryKey: contractTypeKeys.names(),
    queryFn: getContractTypeNames,
  })
}
